import { PageComponent } from '@root/pages/Type';
import Skeleton from 'react-loading-skeleton';
import styles from './ServiceListResource.module.scss';

const ServiceListResourceSkeleton: PageComponent = () => {
    return (
        <div className={styles.resource}>
            <Skeleton width={45} height={45} />
            <div className={styles.text}>
                <h2>
                    <Skeleton width={76} />
                </h2>
                <h3>
                    <Skeleton width={76} />
                </h3>
            </div>
        </div>
    );
};

export default ServiceListResourceSkeleton;
